import { render } from "./succeed.vue?vue&type=template&id=6f77e208&scoped=true"
import script from "./succeed.vue?vue&type=script&lang=js"
export * from "./succeed.vue?vue&type=script&lang=js"

import "./succeed.vue?vue&type=style&index=0&id=6f77e208&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f77e208"

export default script